import styled from '@emotion/styled';

export interface ITextXsDefaultWrapper {
  weight?: 'regular' | 'bold' | 'semibold' | 'medium';
}

export const TextXsDefaultWrapper = styled.p<ITextXsDefaultWrapper>`
  font-family: 'Inter';
  font-size: 12px;
  color: ${({ theme }) => theme.palette?.brand.secondary.base};
  font-weight: ${({ weight }) => (weight ? weight : 'regular')};
  line-height: 18px;

  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.tablet + 'px'}){
    font-size: clamp(12px, 1.5vw, 16px);
  }
`;
